import { Service2026Details } from "../../../types/servicePackageType";
import { colors } from "../../../styles";

colors.simple_funeral_green_bg;

export const 무빈소장2026: Service2026Details = {
  type: "무빈소장",
  backgroundColor: colors.simple_funeral_green_bg,
  mainColor: colors.green450,
  subColor: colors.simple_funeral_green_bg_sub,
  description: `빈소와 조문이 없는 간소한 소규모 장례 서비스로 
합리적인 비용의 장례를 진행하실 수 있어요.`,
  summary: `조문객 없이 간소한 장례`,
  recommendationText: `<b>고이 무빈소장은,</b> 
  빈소와 조문 없이 가족만 모여, 
  간소한 절차와 합리적 비용의 
  장례를 희망하는 분께 추천드립니다.`,
  정상가: 170,
  가격: 159,
  조문객: "",
  빈소: "없음",
  접객도우미: "없음",
  "장례 용품": "기본형",
  "장의 차량": 1,
  imageSrc: "platform/service/service_simple_figure.png",
  details: [
    {
      key: "용품",
      contents: [
        {
          src: "platform/service/gwan0-2025.png",
          title: "0.6 오동관",
          descriptions: `화장용`,
          price: 200_000,
        },
        {
          src: "platform/service/sui1.png",
          title: "화장용 수의",
          descriptions: `(면 50%, 폴리 50%)`,
          price: 250_000,
          discountPrice: 140_000,
        },
        {
          src: "platform/service/5.png",
          title: "입관 수시 용품",
          descriptions: "15종(염포, 관보 등)",
          price: 150_000,
        },
        {
          src: "platform/service/ugol0.png",
          title: "유골함",
          descriptions: "(오동나무 목함)",
          price: 0,
        },
        {
          src: "platform/service/6.png",
          title: "관 장식용 생화",
          descriptions: "계절 생화, 안개꽃",
          price: 100_000,
        },
      ],
    },
    {
      key: "인력",
      contents: [
        {
          src: "platform/service/person1.png",
          title: "장례지도사",
          descriptions: "1인 3일",
          price: 300_000,
        },
        {
          src: "platform/service/person2.png",
          title: "염습상례사",
          descriptions: "1인 1일",
          price: 150_000,
        },
      ],
    },

    {
      key: "차량",
      contents: [
        {
          src: "platform/service/ambulance.png",
          title: "고인이송차량",
          descriptions: `관내 이송`,
          price: 100_000,
        },
        {
          src: "platform/service/limousine_and_bus.png",
          title: "리무진/장의버스 택1",
          descriptions: `리무진: 200km 화장장 편도\n장의버스: 200km 왕복`,
          price: 450_000,
        },
      ],
    },
  ],
  extraDetails: [
    {
      key: "희망하시는 경우 용품을 변경할 수 있습니다",
      contents: {
        유골함: [
          {
            src: "platform/service/ugol0.png",
            title: "오동나무 목함",
            descriptions: "(오동나무 목함)",
            price: 0,
            discountPrice: 0,
          },
          {
            src: "platform/service/ugol1-2025.png",
            title: "일반 유골함",
            descriptions: ``,
            price: 250_000,
            discountPrice: 150_000,
          },
        ],
        수의: [
          {
            src: "platform/service/sui1.png",
            title: "화장용 수의",
            descriptions: `(면 50%, 폴리 50%)`,
            price: 250_000,
            discountPrice: 140_000,
          },
          {
            src: "platform/service/sui1-2025.png",
            title: "고급 면 가진수의",
            descriptions: `고급 면 100% 가진수의`,
            price: 300_000,
            discountPrice: 200_000,
          },
        ],
        차량: [
          {
            src: "platform/service/bus.png",
            title: "45인승 장의버스",
            descriptions: `200km 왕복`,
            price: 450_000,
          },
          {
            src: "platform/service/limousine.png",
            type: "차량",
            title: `리무진`,
            descriptions: "",
            // title: "3일차 고인 이송 차량",
            // descriptions: `리무진
            //   (200km 초과시
            //   km 당 2,000원 추가)`,
            price: 450_000,
          },
        ],
        매장용품: [
          {
            src: "platform/service/gwan1-2025.png",
            title: "매장용 관으로 변경",
            descriptions: `10만원 추가`,
            price: (30 - 20) * 10_000,
          },
          {
            src: "platform/service/5.png",
            title: "매장 용품 추가",
            descriptions: `25만원 추가`,
            price: (12 + 13) * 10_000,
          },
        ],
      },
    },
  ],
  steps: [
    [
      {
        src: "images/service/first_1.png",
        title: "고인 이송",
        description: "임종 후, 병원이나 장례식장으로 이송합니다.",
      },
      {
        src: "images/service/first_2.png",
        title: "고인 안치",
        description:
          "고인의 옷과 몸을 바르게 하는 수시 후, 고인을 장례식장에 안치합니다.",
      },
      {
        src: "images/service/first_4.png",
        title: "화장장 예약",
        description:
          "2일차에 화장이 가능하도록 장례지도사님께서 미리 화장장 예약을 진행합니다.",
      },
      {
        src: "images/service/first_5.png",
        title: "부고 문자 발송",
        description:
          "꼭 필요한 정보가 누락되지 않도록 부고문자를 작성해드립니다.",
      },
    ],
    [
      {
        src: "images/service/second_1.png",
        title: "염습",
        description:
          "고인의 몸을 깨끗이 한 후, 수의를 입힙니다. 입관 전에 거치는 절차입니다.",
      },
      {
        src: "images/service/second_2.png",
        title: "입관식",
        description:
          "염습 후 고인의 마지막 모습을 보면서 애도할 수 있는 입관식을 진행합니다.\n" +
          "(고인의 종교에 따라 종교지도사 참여 가능합니다.)",
      },
      {
        src: "images/service/second_3.png",
        title: "성복",
        description:
          "정식으로 상복을 입는 절차입니다. 요즘에는 1일차에 바로 상복을 입지만, 입관 후 정식으로 완장/머리핀을 착용하게 됩니다.",
      },
    ],
    [
      {
        src: "images/service/third_1.png",
        title: "발인",
        description:
          "관이 장례식장을 떠나는 절차이며, 관을 버스나 리무진까지 옮깁니다.",
      },
      {
        src: "images/service/third_2.png",
        title: "운구",
        description:
          "고인을 장지까지 옮기는 절차이며, 버스나 리무진으로 이송합니다.",
      },
      {
        src: "images/service/third_3.png",
        title: "화장 / 유골 안치",
        description: "예약한 시간에 화장 후 안치시설로 옮깁니다.",
      },
      {
        src: "images/service/third_4.png",
        title: "사후 행정",
        description:
          "사망신고, 유족연금, 상속신고 등 법적, 행정적 안내를 도와드립니다.",
      },
    ],
  ],
  deductions: [
    "4일장, 5일장 등 3일장에서 일정이 길어질 경우 장례지도사 서비스 비용이 1일 당 20만원씩 추가됩니다. (무빈소장 15만 원)",
    "접객도우미는 시간 초과 시 시간당 2만 원이 추가되며, 반대로 시간 당 공제는 불가능합니다.",
  ],
  extra: [
    "고인이송차량은 관외 이용 시 추가 비용이 발생하며, 금액은 거리와 상황에 따라 책정됩니다.",
    "정해진 거리(200km)를 초과하여 장의차량을 이용할 경우, 차량 서비스 비용이 1km 당 2천원씩 추가됩니다.",
    "리무진은 편도 이용 기준이며, 초과거리당 1km 당 2천원이 추가됩니다.",
    "장지 이외의 장소에 경유를 요청하는 경우, 이동 거리 및 소요 시간에 따라 별도로 추가 경유비가 발생합니다.",
    "유골함에 각인 서비스를 요청하실 경우 각인비가 최대 2만 원이 발생합니다.",
    "출동 후 서비스 이용을 취소하실 경우 취소 위약금이 기본 25만 원이 발생하며, 고인이송차량, 접객도우미 등 이미 준비가 완료된 품목들에 대해 추가로 비용이 청구됩니다.",
    "장례 진행 중 차량 배차, 접객 도우미 배치 등 이미 준비가 완료된 사항에 대해 취소 요청할 시 공제가 불가능합니다.",
    "사고사 등 특수염이 필요할 경우, 최대 50만 원의 추가금이 발생합니다.",
  ],
};
